import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Scroll from 'react-scroll';

import { Forms, Modal, SaveButton, SystemText } from 'e4shared';

import { saveNotes } from 'actions/profile';
import posthog from 'posthog-js';

export const ManageNote = props => {
    const dispatch = useDispatch();

    const { tags, handles } = useSelector(state => state.ui);
    const { user } = useSelector(state => state.user);

    const [saving, setSaving] = React.useState(false);
    const [notes, setNotes] = React.useState('');
    const [errors, setErrors] = React.useState({});

    React.useEffect(() => {
        setNotes(props.note?.notes || '');
        setErrors({});
    }, [props.note]);

    const validate = note => {
        let result = true;
        const temp = {};

        if (note.notes.length === 0) {
            temp.title = SystemText('User121/Notes/Manage/Note/Error');
            result = false;
        }

        setErrors(temp);

        if (!result) document.getElementsByClassName('modal')[0].scrollTop = 0;

        return result;
    };

    const save = () => {
        const note = {
            ...props.note,
            notes: notes,
        };

        if (validate(note)) {
            dispatch(
                saveNotes(note, () => {
                    setNotes('');
                    user.id !== note.profile_Id && posthog.capture('manager-added-note');
                    closeModal();
                })
            );
        } else {
            setSaving(false);
        }
    };

    const closeModal = () => {
        props.reload && props.reload();
        props.close && props.close();
    };

    const { note, show } = props;

    const footer = (
        <div>
            <SaveButton
                data-testid="button-note-save"
                saving={saving}
                setSaving={setSaving}
                className="btn btn-success"
                onClick={() => save()}
            >
                {SystemText('User121/Notes/Manage/Buttons/Save')}
            </SaveButton>
            <button data-testid="button-note-cancel" className="btn" onClick={closeModal}>
                {SystemText('User121/Notes/Manage/Buttons/Cancel')}
            </button>
        </div>
    );

    const title = note?.id ? SystemText('User121/Notes/Manage/EditTitle') : SystemText('User121/Notes/Manage/AddTitle');

    return (
        <Modal show={show} title={title} close={closeModal} footer={footer}>
            <Scroll.Element name="top-of-modal" />
            <div className="form-group" id="manage-task-form">
                <Forms.Textarea
                    tags={tags}
                    data-testid="text-note"
                    handles={handles}
                    error={errors.title}
                    value={notes}
                    placeholder={SystemText('User121/Notes/Manage/Note/Placeholder')}
                    onChange={setNotes}
                    label={SystemText('User121/Notes/Manage/Note/Label')}
                    rows="10"
                />
            </div>
        </Modal>
    );
};

export default ManageNote;
